export default __webpack_public_path__ + "static/media/img_top_bg.94495bdd.png";